"use client";
import { jsx as o } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import { useInkeepConfig as d } from "../providers/config-provider.js";
const i = a(({ isExternal: e, ...r }, n) => /* @__PURE__ */ o(
  "a",
  {
    target: e ? "_blank" : void 0,
    rel: e ? "noopener" : void 0,
    ...r,
    ref: n
  }
));
i.displayName = "Link";
const f = a(({ href: e, appendToUrl: r, ...n }, t) => {
  const { baseSettings: s } = d(), c = Object.assign({}, s.urlQueryParamsToAppend, r), p = e && m(e, c);
  return /* @__PURE__ */ o(i, { ref: t, href: p, ...n });
});
f.displayName = "LinkWithQueryParams";
function m(e, r) {
  if (!r)
    return e;
  try {
    const n = new URL(e);
    for (const t of Object.keys(r))
      r[t] && n.searchParams.append(t, r[t]);
    return n.href;
  } catch {
    return e;
  }
}
export {
  i as Link,
  f as LinkWithQueryParams
};
